const AuthActions = {
  LOGGED_IN: "auth/logged-in",
};

export default AuthActions;
